import { ArrowRight } from "lucide-react";
import { Reveal, openRegistration } from "./shared";

const LAGGING = [
  "Order Defect Rate: 0.12% (threshold < 1.00%) — GREEN",
  "Late Shipment Rate: 1.4% (threshold < 4.00%) — GREEN",
  "Policy Compliance: 0 active complaints recorded",
  "Dashboard verdict: 'All metrics healthy, no action required'",
];

const RADAR = [
  "NCX spike: +310% velocity on top ASIN",
  "Carrier first-scan delay: 4.2x above 30-day baseline",
  "Brand inauthenticity vector: 3 return keywords matched to bot sweeps",
  "Protego alert: ~72 hours to automated ASIN suppress or Section 3 review",
];

export const SplitScreen = () => (
  <section className="px-4 sm:px-6 lg:px-8 my-14">
    <div
      data-testid="split-screen-section"
      className="max-w-7xl mx-auto bg-slate-900 text-white rounded-3xl border border-slate-800 py-16 lg:py-20 px-6 sm:px-10 lg:px-14 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(40rem 20rem at 85% 0%, rgba(244,63,94,0.08), transparent)" }}
      />
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-indigo-300">
          Live teardown · Same account, same day
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-3xl">
          The receipt says healthy. <span className="text-rose-400">The radar says 72 hours.</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-2 gap-6">
        <Reveal className="h-full">
          <div
            data-testid="seller-central-panel"
            className="h-full rounded-2xl border border-emerald-500/25 bg-emerald-500/5 p-7"
          >
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400">
              Lagging indicator — Amazon Seller Central
            </p>
            <span className="inline-block mt-3 font-mono text-xs font-semibold px-2.5 py-1 rounded-md border text-emerald-400 border-emerald-500/30 bg-emerald-500/10">
              STATUS: 200 / 200 — HEALTHY
            </span>
            <ul className="mt-6 space-y-3">
              {LAGGING.map((d) => (
                <li key={d} className="flex gap-3 text-sm text-slate-300">
                  <span className="font-mono text-emerald-400 shrink-0">[+]</span>
                  {d}
                </li>
              ))}
            </ul>
            <p className="mt-6 pt-5 border-t border-slate-700/60 text-sm text-slate-400">
              <span className="font-semibold text-slate-200">The reality:</span> Amazon's internal
              enforcement queue has already accumulated 14 pre-claim return reason codes in 3 days.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="h-full">
          <div
            data-testid="protegoos-panel"
            className="h-full rounded-2xl border border-rose-500/25 bg-rose-500/5 p-7"
          >
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400">
              Protego AI — predictive intelligence
            </p>
            <span className="inline-block mt-3 font-mono text-xs font-semibold px-2.5 py-1 rounded-md border text-rose-400 border-rose-500/30 bg-rose-500/10">
              STATUS: ELEVATED ENFORCEMENT RISK — 34/100
            </span>
            <ul className="mt-6 space-y-3">
              {RADAR.map((d) => (
                <li key={d} className="flex gap-3 text-sm text-slate-300">
                  <span className="font-mono text-rose-400 shrink-0">[!]</span>
                  {d}
                </li>
              ))}
            </ul>
            <p className="mt-6 pt-5 border-t border-slate-700/60 text-sm text-slate-400">
              <span className="font-semibold text-slate-200">The outcome:</span> the seller intervened,
              rerouted the warehouse batch, and prevented $180,000 in frozen revenue before Amazon fired.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
          <p className="text-sm text-slate-400 max-w-xl">
            In the workshop we run this teardown on a real account, live — both screens side by side.
          </p>
          <button
            data-testid="split-cta-btn"
            onClick={openRegistration}
            className="shrink-0 bg-indigo-500 hover:bg-indigo-600 text-white font-bold text-sm rounded-full px-8 py-3.5 transition-colors duration-200"
          >
            Watch It Live — Reserve My Seat
            <ArrowRight className="inline-block w-4 h-4 ml-1.5 align-middle" strokeWidth={2.5} />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
